// ElabApp.js
import React from "react";
import { Route } from "react-router-dom";
import Home from "./examlab/pages/page";
import TestScreen from "./examlab/pages/TestScreen";
import "../src/App.css";
import ResultPage from "./examlab/pages/ResultPage";
const loadAppStyles = async () => {
    await import("./examlab/elab_index.css");
};
const ElabApp = () => {
  const renderContent = () => {
    loadAppStyles();
    const path = window.location.pathname;

    if (path.includes("/elab/practice-tests/")) {
      return <Home />;
    } else if (path.includes("/elab/quiz/")) {
      return <TestScreen />;
    } else if (path.includes("/elab/test-performance/")) {
      return <ResultPage />;
    } else {
      return <div> 404 - Not fount </div>;
    }
  };

  return <Route path="/elab/*">{renderContent()}</Route>;
};

export default ElabApp;
